import React from 'react';
import { Popover as MuiPopover } from '@mui/material';
import { PopoverProps as MuiPopoverProps } from '@mui/material';
import Loader from '../Loader';
type PopoverProps = {
  children?: React.ReactNode;
  loading?: boolean;
  anchorEl?: MuiPopoverProps['anchorEl'];
  setAnchorEl?: React.Dispatch<React.SetStateAction<any>>;
  onClose?: MuiPopoverProps['onClose'];
} & React.ComponentProps<typeof MuiPopover>;

const Popover = ({
  children,
  loading = false,
  anchorEl,
  setAnchorEl,
  anchorOrigin,
  transformOrigin,
  onClose,
  ...props
}: PopoverProps) => {
  const handleClose = () => {
    if (setAnchorEl) {
      setAnchorEl(null);
    }
  };
  const id = anchorEl ? anchorEl.toString() : undefined;
  return (
    <MuiPopover
      {...props}
      id={id}
      anchorEl={anchorEl}
      onClose={onClose ? onClose : handleClose}
      anchorOrigin={anchorOrigin ? anchorOrigin : { vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={transformOrigin ? transformOrigin : { vertical: 'top', horizontal: 'left' }}
    >
      <div className="popover-body-div">{loading ? <Loader /> : children}</div>
    </MuiPopover>
  );
};

export default Popover;
